module.exports = {"name":"theoplayer2","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.0.0","built":"2017-08-23","repo":"https://bitbucket.org/npaw/theoplayer2-adapter-js","libVersion":"^6.0.4","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getBitrate","getRendition","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 25
// module chunks = 0